export interface CsatBenchmark {
  slug: string;
  industry: string;
  accountCount: number;
  human: { p50: number; p75: number; p90: number };
  fin: { p50: number; p75: number; p90: number };
  /**
   * Simple average of the human and Fin percentile cuts. Not a true percentile
   * of the combined population (no unified "all conversations" benchmark
   * exists yet) — a reasonable proxy until data eng ships one.
   */
  blended: { p50: number; p75: number; p90: number };
}

// Source: INTERCOM_PROD.PRIVATE_RAD.FCT_INDUSTRY_METRIC_BENCHMARKS_MONTHLY, calendar_month = 2026-07-01.
// Industries below 30 qualifying accounts are omitted to prevent de-anonymization,
// matching the in-product CX Score Benchmarking threshold.
export const CSAT_BENCHMARKS_AS_OF = "2026-07-01";

export const CSAT_BENCHMARKS: CsatBenchmark[] = [
  {
    slug: "all-industries",
    industry: "All industries",
    accountCount: 1557,
    human: { p50: 0.8836, p75: 0.94, p90: 0.9852 },
    fin: { p50: 0.7973, p75: 0.8941, p90: 0.9935 },
    blended: { p50: 0.8405, p75: 0.9171, p90: 0.9893 },
  },
  {
    slug: "software-technology",
    industry: "Software & Technology",
    accountCount: 792,
    human: { p50: 0.9091, p75: 0.9587, p90: 1.0 },
    fin: { p50: 0.8061, p75: 0.8982, p90: 1.0 },
    blended: { p50: 0.8576, p75: 0.9284, p90: 1.0 },
  },
  {
    slug: "fintech-financial-services",
    industry: "Fintech / Financial Services",
    accountCount: 272,
    human: { p50: 0.836, p75: 0.9129, p90: 0.9602 },
    fin: { p50: 0.7805, p75: 0.8797, p90: 1.0 },
    blended: { p50: 0.8082, p75: 0.8963, p90: 0.9801 },
  },
  {
    slug: "healthcare",
    industry: "Healthcare",
    accountCount: 116,
    human: { p50: 0.8748, p75: 0.9324, p90: 0.971 },
    fin: { p50: 0.7876, p75: 0.8992, p90: 0.9815 },
    blended: { p50: 0.8312, p75: 0.9158, p90: 0.9762 },
  },
  {
    slug: "ecommerce",
    industry: "Ecommerce",
    accountCount: 93,
    human: { p50: 0.8655, p75: 0.9148, p90: 0.9652 },
    fin: { p50: 0.7736, p75: 0.9091, p90: 1.0 },
    blended: { p50: 0.8196, p75: 0.912, p90: 0.9826 },
  },
  {
    slug: "education",
    industry: "Education",
    accountCount: 82,
    human: { p50: 0.9265, p75: 0.9639, p90: 1.0 },
    fin: { p50: 0.8453, p75: 0.9244, p90: 1.0 },
    blended: { p50: 0.8859, p75: 0.9441, p90: 1.0 },
  },
  {
    slug: "transportation",
    industry: "Transportation",
    accountCount: 49,
    human: { p50: 0.8653, p75: 0.9235, p90: 0.9642 },
    fin: { p50: 0.7447, p75: 0.8834, p90: 1.0 },
    blended: { p50: 0.805, p75: 0.9034, p90: 0.9821 },
  },
  {
    slug: "real-estate",
    industry: "Real Estate",
    accountCount: 47,
    human: { p50: 0.8519, p75: 0.928, p90: 0.972 },
    fin: { p50: 0.8, p75: 0.9103, p90: 1.0 },
    blended: { p50: 0.8259, p75: 0.9192, p90: 0.986 },
  },
  {
    slug: "gaming-and-gambling",
    industry: "Gaming and Gambling",
    accountCount: 39,
    human: { p50: 0.7033, p75: 0.8061, p90: 0.9464 },
    fin: { p50: 0.6333, p75: 0.6903, p90: 0.7943 },
    blended: { p50: 0.6683, p75: 0.7482, p90: 0.8704 },
  },
  {
    slug: "professional-services",
    industry: "Professional Services",
    accountCount: 36,
    human: { p50: 0.9091, p75: 0.9526, p90: 0.9872 },
    fin: { p50: 0.8581, p75: 0.9135, p90: 1.0 },
    blended: { p50: 0.8836, p75: 0.9331, p90: 0.9936 },
  },
  {
    slug: "hospitality-and-tourism",
    industry: "Hospitality and Tourism",
    accountCount: 31,
    human: { p50: 0.8989, p75: 0.9417, p90: 1.0 },
    fin: { p50: 0.9167, p75: 1.0, p90: 1.0 },
    blended: { p50: 0.9078, p75: 0.9709, p90: 1.0 },
  },
];
